module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-4-Australia-Landing-Page-w960.63c6f8a8.jpg";